import scrolltop from './scrolltop/scrolltop.vue'
import navFlex from './nav/nav-flex.vue'
import navStatic from './nav/nav-static.vue'
import navImage from './nav/nav-image.vue'
import share from './share/share.vue'
import loading from './loading/loading.vue'
import goodsList from './goods/goods-list.vue'
import countDown from './countDown/count-down.vue'

const FUI = {
    scrolltop,
    navFlex,
    navStatic,
    navImage,
    share,
    loading,
    goodsList,
    countDown
}

module.exports = FUI



// WEBPACK FOOTER //
// ./src/index.js